// United States-center
const DEFAULT_LOCATION = {
	lat: 39.8283,
	lng: -98.5795,
	zoom: 4,
	source: 'default',
};

const GEOLOCATION_TIMEOUT_MS = 4000;

function getBrowserPosition() {
	return new Promise((resolve, reject) => {
		if (!('geolocation' in navigator)) {
			reject(new Error('Geolocation API is not supported'));
			return;
		}

		navigator.geolocation.getCurrentPosition(
			(position) => {
				resolve({
					lat: position.coords.latitude,
					lng: position.coords.longitude,
					zoom: 10,
					source: 'geolocation',
				});
			},
			(error) => reject(error),
			{
				timeout: GEOLOCATION_TIMEOUT_MS,
				maximumAge: 10 * 60 * 1000,
				enableHighAccuracy: false,
			}
		);
	});
}


const IP_CACHE_KEY = 'geo-ip-cache-v1';
const IP_CACHE_TTL = 30 * 60 * 1000; // 30 min

async function getLocationByIpCached() {
	try {
		const cached = JSON.parse(sessionStorage.getItem(IP_CACHE_KEY) || 'null');
		if (cached && Date.now() - cached.ts < IP_CACHE_TTL) {
			return cached.data;
		}
	} catch { }

	const data = await getLocationByIp();
	try {
		sessionStorage.setItem(IP_CACHE_KEY, JSON.stringify({ data, ts: Date.now() }));
	} catch { }
	return data;
}

// fallback user IP
async function getLocationByIp() {
	// const res = await fetch('https://ipapi.co/json/', { cache: 'no-store' });
	const res = await fetch('https://ipapi.co/json/');
	if (!res.ok) throw new Error('IP geolocation request failed');

	const data = await res.json();
	if (!data.latitude || !data.longitude) {
		throw new Error('IP geolocation returned no coordinates');
	}

	return {
		lat: data.latitude,
		lng: data.longitude,
		zoom: data.country_code === 'US' ? 5 : 6,
		source: 'ip',
		countryCode: data.country_code || null,
	};
}

/*
	1. Geolocation API 
	2. fallback IP
	3. fallback USA
*/
export function useGeoCascade() {
	async function resolveInitialLocation() {
		try {

			return await getBrowserPosition();
		} catch {
			// denied / timed out / unsupported
		}

		try {
			return await getLocationByIpCached();
		} catch {
			// no services / no coordinates
		}

		return { ...DEFAULT_LOCATION };
	}

	// User location
	async function requestPreciseLocation() {
		return getBrowserPosition();
	}

	return {
		resolveInitialLocation,
		requestPreciseLocation,
		DEFAULT_LOCATION,
	};
}
